import { useState } from "react";
import { ThemeToggle } from "@site-factory/ui";
import { SectionShell } from "@site-factory/ui";

export default function ThemePage() {
  const [mode, setMode] = useState<"light" | "dark">(
    typeof window !== "undefined" && localStorage.getItem("sf-theme-mode") === "dark" ? "dark" : "light"
  );

  return (
    <SectionShell>
      <div className="max-w-2xl mx-auto space-y-6">
        <div className="flex items-center justify-between">
          <div>
            <p className="text-sm text-neutral-500 uppercase tracking-wide">Theme</p>
            <h1 className="text-3xl font-bold">Toggle Mode</h1>
          </div>
          <ThemeToggle initialMode={mode} onChange={setMode} />
        </div>
        <p className="text-neutral-600">
          Toggle between light and dark mode. The preference is stored locally. Header and content will reflect the active mode
          using theme tokens.
        </p>
      </div>
    </SectionShell>
  );
}
